import { NgModule } from "@angular/core";

import { CamelCaseToDashPipe } from "./camelCaseToDash.pipe";
import { FilterPipe } from "./filter.pipe";
import { GetByIdPipe } from "./getById.pipe";
import { HtmlToPlaintextPipe } from "./htmlToPlaintext.pipe";
import { KeysPipe } from "./keys.pipe";
import { TruncatePipe } from "./truncate.pipe";

@NgModule({
    declarations: [KeysPipe, GetByIdPipe, HtmlToPlaintextPipe, FilterPipe, CamelCaseToDashPipe, TruncatePipe],
    imports: [],
    exports: [KeysPipe, GetByIdPipe, HtmlToPlaintextPipe, FilterPipe, CamelCaseToDashPipe, TruncatePipe]
})
export class FusePipesModule {}
